import { TableCell, TableRow, Typography } from "@material-ui/core";
import React from "react";
import { useStyles } from "./results-per-package-table";

const ThreePartTableRow = ({
  leftText,
  middleText,
  rightText,
  isHeader = false,
}) => {
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell className={isHeader ? classes.tableHeaderPerExamination : ""}>
        <Typography>{leftText}</Typography>
      </TableCell>

      <TableCell className={isHeader ? classes.tableHeaderPerExamination : ""}>
        <Typography style={{ textAlign: "center" }}>{middleText}</Typography>
      </TableCell>

      <TableCell className={isHeader ? classes.tableHeaderPerExamination : ""}>
        <Typography style={{ textAlign: "right" }}>{rightText}</Typography>
      </TableCell>
    </TableRow>
  );
};

export default ThreePartTableRow;
